<template>
    <b-card no-body>

        <b-card-body>
            <b-card bg-variant="light">
                <div v-if="historico && historico.length > 0">
                    <div v-for="item in this.historico" :key="item.id">
                        <pre>{{ item.historico }}</pre>
                    </div>
                </div>
                <div v-if="historico.length == 0">
                    <span>SEM HISTÓRICO</span>
                </div>
            </b-card>
        </b-card-body>

        <div class="images-container" v-if="modal">
            <img :src="imgPdf" class="img" alt="icone pdf" @click="gerarPDF" />
            <b-button id="cancelarHistoricoSenado" class=" my-2 ml-2" size="sm" pill variant="danger" @click="fecharModal">
                <b-icon icon="x-circle" />
                <b-tooltip target="cancelarHistoricoSenado" title="Cancelar"></b-tooltip>
            </b-button>

        </div>
    </b-card>
</template>

<script>
import HistoricoSenadoService from "@/core/api/HistoricoSenadoService";
import moment from "moment";
import PdfIcon from "@/core/assets/icons/pdf.png";
import FecharIcon from "@/core/assets/icons/fechar.png";
import { geradorDePdf } from "./geradordocs/pdfs";


export default {
    components: {
    },

    props: {
        id: Number,
        modal: Boolean
    },
    data() {
        return {
            busy: false,
            historico: [],
            imgPdf: PdfIcon,
            imgFechar: FecharIcon


        };
    },

    async beforeMount() {
        this.$service = new HistoricoSenadoService;
    },
    async mounted() {
        this.load();
    },

    watch: {
        page() {
            this.load();
        },

    },

    computed: {

        tableFields() {
            return [
                {
                    key: "data",
                    label: "Data",
                    formatter: (data) => moment(String(data)).format("DD/MM/YYYY"),
                },
                { key: "historico", label: "Operação" },
                { key: "responsavel", label: "Responsável" },

            ];
        },
    },

    methods: {
        async load() {

            let vm = this;
            this.busy = true
            this.$service.findByIdItemBemPermanente(this.id).then(response => {
                vm.historico = response.data;
                vm.busy = false;
            });

        },
        fecharModal() {
            this.$emit('fecharModal');
        },
        gerarPDF() {
            geradorDePdf("rSIBP", this.historico[0].itemBemPermanente, this.historico[0].historico, "HISTÓRICO DE ITEM BEM PERMANENTE DO SENADO");
        }



    },
};
</script>